export default {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  install: (): any => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params?.client_id) {
      sessionStorage.setItem('clientID', params?.client_id);
    }
    if (params?.redirect_uri) {
      sessionStorage.setItem('redirectURI', params?.redirect_uri);
    }
  }
};

export const cleanSessionStorage = (): void => {
  sessionStorage.removeItem('clientID');
  sessionStorage.removeItem('redirectURI');
};
